import React from 'react';
import FooterLogoV1 from './FooterContent/FooterLogoV1';
import FooterSocialV1 from './FooterContent/FooterSocialV1';
import FooterCopyrightV1 from './FooterContent/FooterCopyrightV1';
import FooterLinksV1 from './FooterContent/FooterLinksV1';
import appGoogleTracking from '../../modules/googletracking';

const footerV1 = () => (
    <footer className="footer__container_v1">
        <hr className='break-footer'></hr>
        <div className="grid-row footer__head_v1">
            <FooterLogoV1 />
            <FooterSocialV1 />
            <FooterLinksV1 />
             <FooterCopyrightV1 />
            <div className='js-scroll-top' />
        </div>
    </footer>
);

export default footerV1;